import { CreateSelectSimple, CreateSelectWithApi } from './Inputs'
import FormValidator from './validator'
import FormModalWrapper from './modal-wrapper'
import CreateInputText from './Inputs/CreateInputText'
import CreateTextEditor from './Inputs/create.text-editor'
import CreateFormGridLayout from './create.form-grid-layout'

class DinoFormBase {
  ModalWrap = FormModalWrapper
  FormValidator = FormValidator
  validator = FormValidator.initial
  createFormGridLayout = CreateFormGridLayout
  createSelectSimple = CreateSelectSimple
  createSelectWithApi = CreateSelectWithApi
  createTextEditor = CreateTextEditor
  createInputText = CreateInputText
}

const DinoForm = new DinoFormBase()
export default DinoForm
